<template>
  <documents />
</template>

<script>
import Documents from '@/views/documents/components/documents'
import ContentMixin from '@/mixins/content-mixin'

export default {
  name: 'DocumentsView',
  components: {
    Documents
  },
  mixins: [
    ContentMixin
  ],
  beforeRouteLeave (to, from, next) {
    this.ContentMixin_Leave(next)
  }
}
</script>
